import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

/** Seconds left until `at`, ticking down while it's in the future. */
function useSecondsUntil(at) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (!at) {
      return undefined;
    }
    const timer = setInterval(() => setNow(Date.now()), 250);
    return () => clearInterval(timer);
  }, [at]);
  return at ? Math.max(0, Math.ceil((at - now) / 1000)) : 0;
}

/**
 * The move waiting for its Undo, in words for the turn banner, or null: "Charmeleon goes to the Bench and Machop
 * comes up in 3 s."
 */
export default function usePendingUndo() {
  const undo = useSelector((state) => state.undo);
  // Once it's on its way there's nothing to undo.
  const pending = undo && !undo.sending ? undo : null;
  const seconds = useSecondsUntil(pending ? pending.sendsAt : null);
  if (!pending) {
    return null;
  }
  return { title: pending.title, hint: seconds > 0 ? `${pending.words} in ${seconds} s.` : `${pending.title}…` };
}
